import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Box, Flex } from 'rebass/styled-components';
import { AsyncButton, Button, FormInput, Modal } from '@getro/rombo';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

export function FolderNameModal({ title, label, initialValue, confirmText, isLoading, onCancel, onSubmit }) {
  const validationSchema = Yup.object().shape({
    folderName: Yup.string().trim().required('Required'),
  });

  const initialValues = {
    folderName: initialValue || '',
  };

  return (
    <Box data-testid="folder-name-modal" onClick={(e) => e.stopPropagation()}>
      {createPortal(
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={({ folderName }) => onSubmit(folderName.trim())}
        >
          {({ handleSubmit }) => (
            <Modal
              title={title}
              isOpen
              onCancel={onCancel}
              actions={
                <Flex sx={{ gap: '8px', justifyContent: 'flex-end' }}>
                  <Button variant="secondary" onClick={onCancel}>
                    Cancel
                  </Button>
                  <AsyncButton data-testid="folder-name-confirm" onClick={() => handleSubmit()} loading={isLoading}>
                    {confirmText}
                  </AsyncButton>
                </Flex>
              }
            >
              <Form>
                <Field required name="folderName" label={label} component={FormInput} autoFocus />
                <Button variant="variants.srOnly" type="submit">
                  {confirmText}
                </Button>
              </Form>
            </Modal>
          )}
        </Formik>,
        document.getElementById('portals'),
      )}
    </Box>
  );
}

FolderNameModal.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  confirmText: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

FolderNameModal.defaultProps = {
  initialValue: '',
  isLoading: false,
};

export default FolderNameModal;
